var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer-container"},[_c('p',[_vm._v("Copyright © "+_vm._s(_vm.year)+" Superintendence of Cultural Heritage ® All Rights Reserved.")]),_c('p',[_vm._v("Version 1.0.0")])])
}
var staticRenderFns = []

export { render, staticRenderFns }